import { TeamsUserCredential } from "@microsoft/teamsfx";
import { app } from "@microsoft/teams-js";
import { createContext } from "react";

export const TeamsFxContext = createContext<{
  teamsUserCredential?: TeamsUserCredential;
  context?: app.Context;
}>({
  teamsUserCredential: undefined,
});
